// import React, { useState, useEffect } from "react";

// const ConventionHall = () => {
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [showBooking, setShowBooking] = useState(false);
//   const [currentSlide, setCurrentSlide] = useState(0);

//   const facilityList = [
//     "🎤 Sound System & AV Equipment",
//     "🪑 Premium Seating Arrangements",
//     "📶 High-Speed Wi-Fi",
//     "🍽️ Catering Services",
//     "🚗 Ample Parking",
//     "🌿 Outdoor Lawn Area",
//     "🎨 Stage & Lighting Setup",
//     "🖥️ Projector & Screens",
//     "💺 VIP Lounge",
//     "🧹 Cleaning Services",
//     "🥂 Bar Services",
//     "🎸 Live Music Setup",
//     "🛡️ Security Services",
//     "🛋️ Lounge Furniture",
//     "🌸 Decoration Options",
//     "🪟 Air Conditioning",
//   ];

//   const galleryImages = [
//     "https://res.cloudinary.com/dxdvcplbl/image/upload/v1757782074/convention_2-min_ay2m2s.jpg",
//     "https://res.cloudinary.com/dxdvcplbl/image/upload/v1757782063/convention_3-min_fsbysp.jpg",
//     "https://res.cloudinary.com/dxdvcplbl/image/upload/v1757782064/convention_1-min_mlwwpc.jpg",
//     "https://res.cloudinary.com/dxdvcplbl/image/upload/v1757782061/convention_4-min_ywmmhb.jpg",
//   ];

//   // Auto slide every 3 seconds
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentSlide((prev) => (prev + 1) % galleryImages.length);
//     }, 5000);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div className="bg-[#fdfdfc] min-h-screen py-12 px-6 md:px-20">
//       <div className="max-w-6xl mx-auto">
//         <h1 className="text-3xl md:text-4xl font-bold text-center mb-5 uppercase">
//           Convention Hall
//         </h1>

//         {/* Carousel */}
//         <div className="relative mb-12 overflow-hidden rounded-3xl shadow-2xl">
//           <div
//             className="flex transition-transform duration-1000 ease-in-out"
//             style={{ transform: `translateX(-${currentSlide * 100}%)` }}
//           >
//             {galleryImages.map((img, idx) => (
//               <img
//                 key={idx}
//                 src={img}
//                 alt={`Hall ${idx + 1}`}
//                 className="w-full h-80 md:h-[500px] object-cover flex-shrink-0 cursor-pointer hover:scale-105 transition-transform rounded-3xl"
//                 onClick={() => setSelectedImage(img)}
//               />
//             ))}
//           </div>

//           {/* Dots */}
//           <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
//             {galleryImages.map((_, idx) => (
//               <div
//                 key={idx}
//                 className={`w-3 h-3 rounded-full ${
//                   idx === currentSlide ? "bg-lime-500" : "bg-gray-300"
//                 }`}
//               ></div>
//             ))}
//           </div>
//         </div>

//         {/* Facilities */}
//         <div className="bg-white shadow-2xl rounded-3xl p-6 mb-12 border border-gray-200 max-h-96 overflow-y-auto">
//           <h2 className="text-2xl md:text-3xl font-bold mb-4 text-lime-600">
//             🛠️ Available Facilities
//           </h2>
//           <ul className="space-y-3">
//             {facilityList.map((facility, idx) => (
//               <li
//                 key={idx}
//                 className="p-3 bg-indigo-50 text-lime-800 rounded-xl shadow-sm hover:shadow-md transition flex items-center gap-3"
//               >
//                 {facility}
//               </li>
//             ))}
//           </ul>
//         </div>

//         {/* Prebook & Contact */}
//         {/* <div className="bg-gradient-to-r from-indigo-50 via-white to-indigo-50 shadow-2xl rounded-3xl p-8 text-center border border-indigo-100 transform transition hover:-translate-y-1 hover:scale-105">
//           <h2 className="text-2xl md:text-3xl font-bold mb-4 text-indigo-700">
//             📞 Prebook & Contact
//           </h2>
//           <p className="text-lg md:text-xl font-medium text-gray-800 mb-4">
//             Reserve your spot or inquire about our facilities.
//           </p>
//           <button
//             onClick={() => setShowBooking(true)}
//             className="bg-indigo-500 text-white py-3 px-6 md:px-8 rounded-full font-semibold shadow-lg transition transform hover:scale-105 hover:shadow-2xl"
//           >
//             Prebook Now
//           </button>
//         </div> */}
//         <div className="bg-gradient-to-r from-indigo-50 via-white to-indigo-50 shadow-2xl rounded-3xl p-6 md:p-8 text-center border border-indigo-100 transition transform hover:-translate-y-1 hover:scale-105 mb-12">
//           <h2 className="text-xl sm:text-2xl font-bold mb-4 text-lime-700">
//             ⏰ Opening Hours
//           </h2>
//           <ul className="space-y-1 sm:space-y-2 text-gray-700 mb-4 sm:mb-6">
//             <li>Monday - Friday: 10:00 AM - 10:00 PM</li>
//             <li>Saturday - Sunday: 9:00 AM - 11:00 PM</li>
//           </ul>
//           <h3 className="text-xl sm:text-2xl font-bold mb-2 text-lime-600">
//             For Pre-Booking
//           </h3>
//           <p className="text-base sm:text-lg font-medium text-gray-800">
//             Call: +88 01766693142
//           </p>
//         </div>
//       </div>

//       {/* Booking Modal */}
//       {showBooking && (
//         <div
//           className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
//           onClick={() => setShowBooking(false)}
//         >
//           <div
//             className="relative bg-white p-6 rounded-2xl shadow-lg w-full max-w-md"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               className="absolute top-2 right-2 text-gray-700 bg-gray-200 rounded-full px-3 py-1 hover:bg-gray-300"
//               onClick={() => setShowBooking(false)}
//             >
//               ✕
//             </button>
//             <h2 className="text-2xl font-semibold mb-4 text-center">
//               📝 Prebook the Hall
//             </h2>
//             <form
//               className="grid gap-4"
//               onSubmit={(e) => {
//                 e.preventDefault();
//                 setShowBooking(false);
//               }}
//             >
//               <input
//                 type="text"
//                 placeholder="Your Name"
//                 className="border rounded-lg p-3 focus:ring-2 focus:ring-indigo-400 outline-none"
//               />
//               <input
//                 type="date"
//                 className="border rounded-lg p-3 focus:ring-2 focus:ring-indigo-400 outline-none"
//               />
//               <input
//                 type="text"
//                 placeholder="Type of Event"
//                 className="border rounded-lg p-3 focus:ring-2 focus:ring-indigo-400 outline-none"
//               />
//               <input
//                 type="number"
//                 placeholder="Expected Guests"
//                 className="border rounded-lg p-3 focus:ring-2 focus:ring-indigo-400 outline-none"
//               />
//               <button
//                 type="submit"
//                 className="bg-indigo-500 hover:bg-indigo-600 text-white py-3 px-4 rounded-lg font-semibold transition"
//               >
//                 Reserve Now
//               </button>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Image Modal */}
//       {selectedImage && (
//         <div
//           className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
//           onClick={() => setSelectedImage(null)}
//         >
//           <div
//             className="relative bg-white p-4 rounded-2xl shadow-lg"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               className="absolute top-2 right-2 text-gray-700 bg-gray-200 rounded-full px-3 py-1 hover:bg-gray-300"
//               onClick={() => setSelectedImage(null)}
//             >
//               ✕
//             </button>
//             <img
//               src={selectedImage}
//               alt="Enlarged view"
//               className="max-w-[90vw] max-h-[80vh] rounded-lg"
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ConventionHall;

import React, { useState, useEffect } from "react";
import {
  Calendar,
  Users,
  Clock,
  Phone,
  Sparkles,
  Star,
  Award,
  Music,
  Coffee,
  Wifi,
  Car,
  TreePine,
  Palette,
  Shield,
  Wind,
  Tv,
  Sofa,
  Gift,
  Camera,
  X,
  ChevronLeft,
  ChevronRight,
  Building,
  CheckCircle,
  ArrowRight,
  MapPin,
  Mail,
} from "lucide-react";

const ConventionHall = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [showBooking, setShowBooking] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const facilityList = [
    {
      icon: <Music className="w-5 h-5" />,
      text: "Sound System & AV Equipment",
      color: "from-purple-500 to-pink-500",
    },
    {
      icon: <Sofa className="w-5 h-5" />,
      text: "Premium Seating Arrangements",
      color: "from-amber-500 to-orange-500",
    },
    {
      icon: <Wifi className="w-5 h-5" />,
      text: "High-Speed Wi-Fi",
      color: "from-blue-500 to-cyan-500",
    },
    {
      icon: <Coffee className="w-5 h-5" />,
      text: "Catering Services",
      color: "from-emerald-500 to-lime-500",
    },
    {
      icon: <Car className="w-5 h-5" />,
      text: "Ample Parking",
      color: "from-gray-600 to-gray-800",
    },
    {
      icon: <TreePine className="w-5 h-5" />,
      text: "Outdoor Lawn Area",
      color: "from-green-500 to-emerald-500",
    },
    {
      icon: <Camera className="w-5 h-5" />,
      text: "Stage & Lighting Setup",
      color: "from-yellow-500 to-amber-500",
    },
    {
      icon: <Tv className="w-5 h-5" />,
      text: "Projector & Screens",
      color: "from-indigo-500 to-purple-500",
    },
    {
      icon: <Star className="w-5 h-5" />,
      text: "VIP Lounge",
      color: "from-rose-500 to-pink-500",
    },
    {
      icon: <Shield className="w-5 h-5" />,
      text: "Cleaning Services",
      color: "from-teal-500 to-emerald-500",
    },
    // {
    //   icon: <Gift className="w-5 h-5" />,
    //   text: "Bar Services",
    //   color: "from-red-500 to-orange-500",
    // },
    {
      icon: <Music className="w-5 h-5" />,
      text: "Live Music Setup",
      color: "from-purple-500 to-indigo-500",
    },
    {
      icon: <Shield className="w-5 h-5" />,
      text: "Security Services",
      color: "from-gray-700 to-gray-900",
    },
    {
      icon: <Sofa className="w-5 h-5" />,
      text: "Lounge Furniture",
      color: "from-amber-500 to-yellow-500",
    },
    {
      icon: <Palette className="w-5 h-5" />,
      text: "Decoration Options",
      color: "from-pink-500 to-rose-500",
    },
    {
      icon: <Wind className="w-5 h-5" />,
      text: "Air Conditioning",
      color: "from-blue-500 to-indigo-500",
    },
  ];

  const galleryImages = [
    "https://res.cloudinary.com/dxdvcplbl/image/upload/v1789981514/convention_hall_h0xsdm.png",
    "https://res.cloudinary.com/dxdvcplbl/image/upload/v1789981514/convention_hall_5_dzqkyw.jpg",
    "https://res.cloudinary.com/dxdvcplbl/image/upload/v1789981514/convetion_hall_4_e4foev.jpg",
    "https://res.cloudinary.com/dxdvcplbl/image/upload/v1789981514/convention_hall_2_mzqaex.png",
  ];

  // Auto slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % galleryImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % galleryImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + galleryImages.length) % galleryImages.length,
    );
  };

  const eventTypes = [
    { name: "Weddings", icon: "💒", count: "100+" },
    { name: "Corporate", icon: "🏢", count: "50+" },
    { name: "Birthdays", icon: "🎂", count: "200+" },
    { name: "Conferences", icon: "🎤", count: "75+" },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-blue-900 via-indigo-800 to-purple-800 text-white py-16 md:py-20 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-purple-600/20 rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 md:px-8 text-center">
          <div className="inline-flex items-center justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full blur-lg opacity-50"></div>
              <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-blue-300/20 to-purple-300/20 backdrop-blur-sm border-2 border-blue-300/30 flex items-center justify-center shadow-2xl">
                <Building className="w-10 h-10 text-white" />
              </div>
            </div>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Premium{" "}
            <span className="relative inline-block">
              <span className="relative z-10">Convention Hall</span>
              {/* <span className="absolute bottom-2 left-0 w-full h-3 bg-gradient-to-r from-blue-400 to-purple-400 -rotate-1"></span> */}
            </span>
          </h1>

          <p className="text-xl text-blue-100 max-w-3xl mx-auto mb-8">
            Elegant venue for memorable events, equipped with{" "}
            <span className="font-bold">300+ seating</span> capacity
            state-of-the-art facilities in the heart of RGCC
          </p>

          <div className="flex flex-wrap items-center justify-center gap-6">
            <div className="flex items-center gap-2 text-blue-200">
              <Sparkles className="w-5 h-5" />
              <span>Full Service</span>
            </div>
            <div className="w-1 h-1 bg-blue-300 rounded-full"></div>
            <div className="flex items-center gap-2 text-blue-200">
              <Award className="w-5 h-5" />
              <span>Premium Venue</span>
            </div>
            {/* <div className="w-1 h-1 bg-blue-300 rounded-full"></div>
            <div className="flex items-center gap-2 text-blue-200">
              <Users className="w-5 h-5" />
              <span>Up to 500 Guests</span>
            </div> */}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        {/* Image Gallery */}
        <div className="relative mb-16">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl group">
            <img
              src={galleryImages[currentSlide]}
              alt={`Hall View ${currentSlide + 1}`}
              className="w-full h-80 md:h-[500px] object-cover transition-transform duration-1000 transform group-hover:scale-105 cursor-pointer"
              onClick={() => setSelectedImage(galleryImages[currentSlide])}
            />

            {/* Navigation Buttons */}
            <button
              onClick={prevSlide}
              className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center text-gray-800 hover:bg-white hover:scale-110 transition-all duration-300 shadow-lg"
            >
              <ChevronLeft className="w-6 h-6" />
            </button>

            <button
              onClick={nextSlide}
              className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center text-gray-800 hover:bg-white hover:scale-110 transition-all duration-300 shadow-lg"
            >
              <ChevronRight className="w-6 h-6" />
            </button>

            {/* View Fullscreen Button */}
            <button
              onClick={() => setSelectedImage(galleryImages[currentSlide])}
              className="absolute top-4 right-4 w-12 h-12 rounded-full bg-black/20 backdrop-blur-sm flex items-center justify-center text-white hover:bg-black/30 hover:scale-110 transition-all duration-300"
            >
              <Camera className="w-5 h-5" />
            </button>

            {/* Dots Indicator */}
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
              {galleryImages.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setCurrentSlide(idx)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    idx === currentSlide
                      ? "bg-gradient-to-r from-blue-500 to-purple-500 w-8"
                      : "bg-white/70 hover:bg-white"
                  }`}
                  aria-label={`Go to slide ${idx + 1}`}
                />
              ))}
            </div>

            {/* Image Counter */}
            <div className="absolute top-4 left-4 px-3 py-1.5 rounded-full bg-black/50 backdrop-blur-sm text-white text-sm">
              {currentSlide + 1} / {galleryImages.length}
            </div>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 mb-16">
          {/* Facilities Section */}
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 md:p-8 border border-blue-100">
            <div className="flex items-center gap-4 mb-8">
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center">
                <Sparkles className="w-7 h-7 text-blue-600" />
              </div>
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
                  Available Facilities
                </h2>
                <p className="text-gray-600">
                  Everything you need for a perfect event
                </p>
              </div>
            </div>

            <div className="grid sm:grid-cols-2 gap-4 max-h-[400px] overflow-y-auto pr-2">
              {facilityList.map((facility, idx) => (
                <div
                  key={idx}
                  className="group flex items-center gap-4 p-4 rounded-xl border border-gray-100 hover:border-blue-200 hover:shadow-md transition-all duration-300"
                >
                  <div
                    className={`w-12 h-12 rounded-lg bg-gradient-to-br ${facility.color} bg-opacity-10 flex items-center justify-center`}
                  >
                    <div
                      className={`bg-gradient-to-r ${facility.color} bg-clip-text text-transparent`}
                    >
                      {facility.icon}
                    </div>
                  </div>
                  <span className="font-medium text-gray-700 group-hover:text-blue-700 transition-colors">
                    {facility.text}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Hours & Booking Section */}
          <div className="space-y-8">
            {/* Opening Hours */}
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl shadow-xl p-6 md:p-8 border border-blue-100">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-blue-100 to-indigo-100 flex items-center justify-center">
                  <Clock className="w-7 h-7 text-blue-600" />
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-900">
                    Opening Hours
                  </h2>
                  <p className="text-gray-600">
                    Plan your event with our schedule
                  </p>
                </div>
              </div>

              <div className="space-y-4">
                <div className="flex items-center justify-between p-4 bg-white rounded-xl border border-blue-100">
                  <div className="flex items-center gap-3">
                    <Calendar className="w-5 h-5 text-blue-500" />
                    <span className="font-medium text-gray-700">
                      Monday - Friday
                    </span>
                  </div>
                  <span className="font-bold text-blue-600">
                    10:00 AM - 10:00 PM
                  </span>
                </div>
                <div className="flex items-center justify-between p-4 bg-white rounded-xl border border-blue-100">
                  <div className="flex items-center gap-3">
                    <Calendar className="w-5 h-5 text-purple-500" />
                    <span className="font-medium text-gray-700">
                      Saturday - Sunday
                    </span>
                  </div>
                  <span className="font-bold text-purple-600">
                    9:00 AM - 11:00 PM
                  </span>
                </div>
              </div>

              {/* Capacity Info */}
              {/* <div className="mt-8 pt-8 border-t border-blue-100">
                <div className="flex items-center gap-3 text-gray-600">
                  <Users className="w-5 h-5 text-blue-500" />
                  <span className="font-medium">
                    Maximum Capacity:{" "}
                    <strong className="text-blue-600">500 Guests</strong>
                  </span>
                </div>
              </div> */}
            </div>

            {/* Contact Section */}
            <div className="bg-gradient-to-r from-blue-500 to-purple-500 rounded-2xl shadow-xl p-6 md:p-8 text-white">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold mb-2">Ready to Book?</h3>
                <p className="text-blue-100">
                  Contact us to reserve your date and plan your perfect event
                </p>
              </div>

              <div className="space-y-4">
                <a
                  href="tel:01769660127"
                  className="flex items-center justify-center gap-3 p-4 bg-white/10 backdrop-blur-sm rounded-xl hover:bg-white/20 transition-colors duration-300 group"
                >
                  <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center">
                    <Phone className="w-6 h-6" />
                  </div>
                  <div className="text-left flex-1">
                    <div className="font-semibold">Call for Pre-Booking</div>
                    <div className="text-lg font-bold">01769660127</div>
                  </div>
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform" />
                </a>

                <button
                  onClick={() => setShowBooking(true)}
                  className="w-full flex items-center justify-center gap-3 p-4 bg-white text-blue-600 rounded-xl font-bold hover:bg-blue-50 hover:scale-105 transition-all duration-300 shadow-lg"
                >
                  <Calendar className="w-5 h-5" />
                  <span>Send Inquiry Form</span>
                  <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Event Types */}
        <div className="mb-16">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-3 mb-4">
              <Star className="w-6 h-6 text-blue-500" />
              <h2 className="text-3xl font-bold text-gray-900">
                Perfect For Every Occasion
              </h2>
              <Star className="w-6 h-6 text-purple-500" />
            </div>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Our convention hall has hosted numerous successful events of all
              types
            </p>
          </div>

          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6">
            {eventTypes.map((event, idx) => (
              <div
                key={idx}
                className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 text-center border border-gray-100 shadow-lg hover:shadow-xl hover:-translate-y-2 transition-all duration-300"
              >
                <div className="text-4xl mb-4">{event.icon}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {event.name}
                </h3>
                {/* <div className="text-sm text-gray-500">
                  {event.count} events hosted
                </div> */}
              </div>
            ))}
          </div>
        </div>

        {/* Location & Additional Info */}
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-8 border border-blue-100">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Premier Location
              </h3>
              <p className="text-gray-600 mb-6">
                Situated within the prestigious Rangpur Golf & Country Club, our
                convention hall offers a serene environment with premium
                amenities and easy accessibility.
              </p>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <MapPin className="w-5 h-5 text-blue-500" />
                  <span className="text-gray-700">
                    Ghaghat, Rangpur (Near Ghaghat Bridge)
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <Users className="w-5 h-5 text-blue-500" />
                  <span className="text-gray-700">
                    Capacity: 200-500 guests
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <Car className="w-5 h-5 text-blue-500" />
                  <span className="text-gray-700">Ample parking available</span>
                </div>
              </div>
            </div>
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-blue-100 to-indigo-100 border-2 border-blue-200 mb-6">
                <Award className="w-10 h-10 text-blue-600" />
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">
                Why Choose Our Hall?
              </h4>
              <ul className="space-y-2 text-gray-600 text-left">
                <li className="flex items-center gap-2">
                  <CheckCircle className="w-4 h-4 text-blue-500" />
                  Full-service event management
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle className="w-4 h-4 text-blue-500" />
                  Professional staff support
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle className="w-4 h-4 text-blue-500" />
                  Customizable packages
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle className="w-4 h-4 text-blue-500" />
                  Competitive pricing
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Booking Modal */}
      {showBooking && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div
            className="bg-gradient-to-br from-white via-blue-50/50 to-indigo-50/50 rounded-3xl shadow-2xl p-6 md:p-8 w-full max-w-md transform transition-all duration-500 scale-100 border-2 border-blue-100"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Top decorative accent */}
            <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-blue-400 to-purple-400"></div>

            {/* Header */}
            <div className="text-center mb-6">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-blue-100 to-indigo-100 flex items-center justify-center mx-auto mb-4">
                <Calendar className="w-8 h-8 text-blue-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Event Inquiry Form
              </h3>
              <p className="text-gray-600">
                Fill out the details and we'll contact you shortly
              </p>
            </div>

            <form
              className="space-y-4"
              onSubmit={(e) => {
                e.preventDefault();
                setShowBooking(false);
                // Handle form submission here
              }}
            >
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Your Name
                </label>
                <input
                  type="text"
                  placeholder="John Doe"
                  className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-100 transition-colors"
                  required
                />
              </div>

              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    placeholder="+880 1234567890"
                    className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-100 transition-colors"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Email Address
                  </label>
                  <input
                    type="email"
                    placeholder="john@example.com"
                    className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-100 transition-colors"
                    required
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Event Type
                </label>
                <select className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-100 transition-colors">
                  <option value="">Select event type</option>
                  <option value="wedding">Wedding</option>
                  <option value="corporate">Corporate Event</option>
                  <option value="birthday">Birthday Party</option>
                  <option value="conference">Conference</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Event Date
                  </label>
                  <input
                    type="date"
                    className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-100 transition-colors"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Expected Guests
                  </label>
                  <input
                    type="number"
                    placeholder="e.g., 200"
                    min="50"
                    max="500"
                    className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-100 transition-colors"
                    required
                  />
                </div>
              </div>

              <div className="flex gap-4 pt-4">
                <button
                  type="button"
                  onClick={() => setShowBooking(false)}
                  className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-800 py-3.5 rounded-xl font-semibold transition-colors duration-300"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="flex-1 bg-gradient-to-r from-blue-500 to-purple-500 text-white py-3.5 rounded-xl font-semibold shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300"
                >
                  Submit Inquiry
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Floating Contact Button - number always visible, no click needed */}
      <a
        href="tel:01769660127"
        className="fixed bottom-4 right-4 lg:top-1/2 lg:bottom-auto lg:-translate-y-1/2 z-50 flex items-center gap-3 bg-gradient-to-r from-emerald-500 to-lime-500 text-white px-5 py-3 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105"
      >
        <Phone className="w-5 h-5 flex-shrink-0" />
        <span className="font-semibold whitespace-nowrap">
          Contact us - 01769660127
        </span>
      </a>

      {/* Image Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div
            className="relative max-w-5xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImage}
              alt="Enlarged view"
              className="w-full max-h-[90vh] object-contain rounded-xl shadow-2xl"
            />
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-4 right-4 w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/20 transition-colors duration-300"
            >
              <X className="w-6 h-6" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConventionHall;
